import filters from '@nextories/vue-tasks/src/i18n/langs/fr/filters';

export default {
  ...filters,
  mainFilters: {
    notAssignedUser: {
      title: 'Non assignées',
    },
    today: {
      title: 'Tâches du jour',
    },
    callrequests: {
      title: 'Rappels',
    },
    allTasks: {
      title: 'Toutes les tâches',
    },
    main_prebook_coord_verify: {
      title: 'Devis à vérifier',
    },
    clientRequest: {
      title: 'Demande de contact',
    },
  },
};
